import PasswordRulesInput from './PasswordRulesInput';

export default PasswordRulesInput;
